import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-gold text-navy shadow-lg shadow-black/40 ring-1 ring-inset ring-black/10 transition-[background-color,transform] hover:bg-gold-hover active:scale-[0.98]',
    secondary: 'bg-panel text-white border border-electric/40 transition-[background-color,transform] hover:bg-panel-hover active:scale-[0.98]',
    outline: 'border-2 border-electric bg-transparent text-electric transition-colors hover:bg-panel'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-195" data-mp="om95wmrlj6ea">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-196" data-mp="12limvonmm4jb" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-197" data-mp="xo8mjdyp88gp">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-198" data-mp="1cfhlidohr66i" />}
    </button>;
}